var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2784 34C40.2784 35.0609 39.857 36.0783 39.1069 36.8284C38.3567 37.5786 37.3393 38 36.2784 38H4.27844C3.21758 38 2.20016 37.5786 1.45002 36.8284C0.69987 36.0783 0.278442 35.0609 0.278442 34V6C0.278442 4.93913 0.69987 3.92172 1.45002 3.17157C2.20016 2.42143 3.21758 2 4.27844 2H14.2784L18.2784 8H36.2784C37.3393 8 38.3567 8.42143 39.1069 9.17157C39.857 9.92172 40.2784 10.9391 40.2784 12V34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon_folder.35d1acff7a6e7c322d657e1abc8f7762.svg";
export { ForwardRef as ReactComponent };